import React, {useState} from 'react';
import styles from "../styles/news-widget.module.scss";
import classNames from "classnames";
import {Image} from "../../../core/components/image/image";
import {NewsWidgetItemContent} from "./news-widget.item-content";
import {NewsWidgetItemViewModel} from "../models/news-widget.item.view-model";
import {Link} from "../../../core/components/link/link";
import {NEWS} from "../news-widget.consts";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {NewsItemDataStructureWrapper} from "./news-item-data-structure.wrapper";

export class NewsWidgetProps extends BaseProps {
  item: NewsWidgetItemViewModel
}

export const NewsWidgetItem = (({item, controller}: NewsWidgetProps) => {
  const {image, linkModel, id, sourceId} = item;
  const [imageSource, setImageSource] = useState(image);

  const linkProps = {
    className: classNames(styles.news_item),
    model: linkModel,
    noFollow: !item.isMagazine,
    shouldRenderMicroData: true
  }

  const imageProps = {
    className: classNames(styles.news_image),
    src: imageSource,
    onError: () => setImageSource(NEWS.NEWS_FALLBACK_IMAGE),
    onClick: () => controller.action(NEWS.ACTION_TYPES.onArticleClick, {
      sourceId,
      articleId: id
    }),
  }

  return (
      <NewsItemDataStructureWrapper controller={controller} newsItem={item}>
        <Link {...linkProps}>
          <Image itemProp={"image"} {...imageProps}/>
          <NewsWidgetItemContent item={item}/>
        </Link>
      </NewsItemDataStructureWrapper>)
});
